import { DETECT_UNREACHABLE_ERROR_CODES } from "./constants";
export var DetectErrorType;
(function (DetectErrorType) {
    // The API answered with a readable error (404, 5xx...) or the thunk failed: show "coming soon"
    DetectErrorType["notFound"] = "notFound";
    // The request was blocked (firewall, VPN, corporate network) or the connection failed
    DetectErrorType["unreachable"] = "unreachable";
})(DetectErrorType || (DetectErrorType = {}));
/**
 * Classifies a rejected detect call.
 * Our firewall (AWS WAF) answers 403 without CORS headers, so the browser hides the status and axios reports ERR_NETWORK
 * (it does the same when the preflight is blocked). A readable 403 is kept for when the firewall sends CORS headers:
 * on detect a 403 only comes from the firewall, never from the API.
 * The thunk does not use rejectWithValue, so the status is read from the serialized axios message.
 */
export var getDetectErrorType = function (error) {
    var _a, _b;
    // Non-axios errors (e.g. "Domain does not exist" thrown by the thunk) have no code
    if (!(error === null || error === void 0 ? void 0 : error.code))
        return DetectErrorType.notFound;
    if (DETECT_UNREACHABLE_ERROR_CODES.includes(error.code))
        return DetectErrorType.unreachable;
    var status = Number((_b = (_a = error.message) === null || _a === void 0 ? void 0 : _a.match(/status code (\d{3})/)) === null || _b === void 0 ? void 0 : _b[1]);
    return status === 403 ? DetectErrorType.unreachable : DetectErrorType.notFound;
};
